<template>
  <AppChatMessage :message-date="messageDate" data-locator="summary-content">
    <template #message-author>
      <v-img
        src="@/assets/img/ai_assistant_logo.svg"
        :width="28"
        :height="28"
      />
    </template>

    <slot />
  </AppChatMessage>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppChatMessage from '@/common/app-chat/AppChatMessage.vue'

export default defineComponent({
  name: 'DocumentsAISummaryMessageFromAI' ,
  components: { AppChatMessage },
  props: {
    messageDate: {
      type: String,
      required: true,
    },
  },
})
</script>
